import { render, staticRenderFns } from "./CoOwnersFieldset.vue?vue&type=template&id=5eea335c&"
import script from "./CoOwnersFieldset.vue?vue&type=script&lang=js&"
export * from "./CoOwnersFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports